import { render, staticRenderFns } from "./cModalAlmacenes.vue?vue&type=template&id=08feaf38"
import script from "./cModalAlmacenes.vue?vue&type=script&lang=js"
export * from "./cModalAlmacenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports